export interface ResolveLinkBrandSelectionInput {
  linkBrands: (number | string)[];
  linkSecondaryBrands: (number | string)[];
  ownedMapping: Record<string, string>;
  adoptedMapping: Record<string, string>;
}

export interface ResolvedBrandSelection {
  brands: (number | string)[];
  secondaryBrands: (number | string)[];
}

/**
 * Replay the link's ordered brand refs into recipient-space. Plain numbers pass
 * through (the selection listener's prune is the validity authority for them);
 * a brand-set ULID resolves via the adopted mapping first, then the owned
 * mapping; an unresolved ULID (blocked, or an adoptable set the user did not
 * confirm) is dropped. The first occurrence of any ref across both fields wins,
 * mirroring buildValidateRequest's dedupe (brands processed before secondary).
 */
export function resolveLinkBrandSelection(
  input: ResolveLinkBrandSelectionInput,
): ResolvedBrandSelection {
  const { linkBrands, linkSecondaryBrands, ownedMapping, adoptedMapping } = input;
  const seen = new Set<string>();

  const resolveField = (refs: (number | string)[]): (number | string)[] => {
    const out: (number | string)[] = [];
    for (const ref of refs) {
      if (ref === "" || ref == null) continue;
      const key = String(ref);
      if (seen.has(key)) continue;
      seen.add(key);
      if (typeof ref === "number") {
        out.push(ref);
        continue;
      }
      const resolved = adoptedMapping[ref] ?? ownedMapping[ref];
      if (resolved) out.push(resolved);
    }
    return out;
  };

  return {
    brands: resolveField(linkBrands),
    secondaryBrands: resolveField(linkSecondaryBrands),
  };
}
